import { Box, ListIcon, ListItem } from '@chakra-ui/react';
import React from 'react';
import { IconType } from 'react-icons';
import { useHistory } from 'react-router-dom';
import { DRAWER_WIDTH } from '../../../root-constants';
import { useDrawer } from '../../../state/drawer';

export interface MainMenuItemProps {
  label: string;
  icon: IconType;
  routePath: string;
  selected: boolean;
}

const MainMenuItem: React.FC<MainMenuItemProps> = ({ selected, label, icon, routePath }) => {
  const history = useHistory();
  const { isOpen: isDrawerOpen, onClose: onCloseDrawer } = useDrawer();

  const onClick = () => {
    history.push(routePath);

    if (isDrawerOpen) {
      onCloseDrawer();
    }
  };

  return (
    <ListItem
      onClick={onClick}
      h="50px"
      w={`${DRAWER_WIDTH - 12}px`}
      m="6px"
      borderRadius={4}
      color={`rgba(245, 245, 245, ${selected ? 1 : 0.75})`}
      px="16px"
      py="8px"
      fontSize={16}
      lineHeight="1.5"
      textAlign="left"
      alignItems="center"
      display="flex"
      cursor="pointer"
      bg={selected ? 'rgba(0, 0, 0, 0.08)' : 'transparent'}
      _hover={{ bg: 'rgba(0, 0, 0, 0.08)' }}
    >
      <Box minW="56px">
        <ListIcon as={icon} fontSize={22} color={`rgba(245, 245, 245, ${selected ? 1 : 0.75})`} />
      </Box>
      {label}
    </ListItem>
  );
};

export default MainMenuItem;
